<template>
  <div class="display-rating">
    <StIcon
      v-for="item in maxRating"
      :key="item"
      :color="item <= value ? 'var(--ds-color-chart-16)' : 'var(--ds-color-icon-2)'"
      icon-name="star"
    />
  </div>
</template>

<script>
import StIcon from '@stilingue/st-icon';
import { RATING_TYPE } from '@/store/modules/cards/constants';

export default {
  name: 'DisplayRating',
  components: {
    StIcon,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    surveyType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      rating: 0,
      maxRating: 0,
    };
  },
  mounted() {
    this.maxRating = RATING_TYPE[this.surveyType.toUpperCase()].maxRating;

    this.rating = this.maxRating - this.value;
  },
};
</script>

<style scoped lang="scss">
  .display-rating {
    display: inline-flex;
    flex-direction: row;
  }
</style>
